import { render, staticRenderFns } from "./admin_products.vue?vue&type=template&id=38ff9696&scoped=true"
import script from "./admin_products.vue?vue&type=script&lang=js"
export * from "./admin_products.vue?vue&type=script&lang=js"
import style0 from "./admin_products.vue?vue&type=style&index=0&id=38ff9696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff9696",
  null
  
)

export default component.exports